import React, { useState } from "react";

import { API } from "aws-amplify";
import { sanitizeOutboundLambda } from "../../../graphql/outbound/outboundCRUD";

import { Backdrop, CircularProgress, makeStyles } from "@material-ui/core";

import { SaveButton, useNotify, useRedirect } from "react-admin";
import { useForm } from "react-final-form";

import { getCustomFieldsToSave } from "../../../components/common/CustomFields";
import { logError } from "../../../utils/appUtils";
import { FilePaths, NoteType, OutboundStatus } from "../../../utils/constants";
import { saveRemoveFile, saveRemoveFiles } from "../../../utils/fileUtils";
import {
  createLambdaAppointment,
  validateAppointment,
} from "../../../utils/dateUtils";
import { ConditionalConfirm } from "../../../components/common/ConditionalConfirm";
import {
  autogenPickupNumber,
  formValidate,
} from "../../../managerApp/resources/outboundShipments/OutboundUtils";
import { normalizeValue } from "../../../utils/utils";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
  },
}));

export const ValidateCreateButton = (props) => {
  const classes = useStyles();
  const form = useForm();
  const notify = useNotify();
  const redirect = useRedirect();
  const [isSaving, setIsSaving] = useState(false);
  const [open, setOpen] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");
  const { appUser, account, selectedTimeslot } = props;

  const handleValidateSave = async () => {
    debugger;
    let error = null;
    const isValid = formValidate(form, notify);

    if (isValid) {
      error = await validateAppointment(selectedTimeslot);
    }

    if (error) {
      setConfirmMessage(
        `${selectedTimeslot.time} is no longer available. Please select a new time.`,
      );
      setOpen(true);
    } else handleSave();
  };

  const handleDialogClose = () => setOpen(false);

  const handleSave = async () => {
    debugger;
    setOpen(false);
    props.handleSubmitWithRedirect();
  };

  const transform = async (data) => {
    setIsSaving(true);
    data = { ...data };
    debugger;

    data.active = "true";
    data.status = OutboundStatus.ADVICE_PENDING;
    data.groups = account?.groups;
    data.reloadYardId = appUser?.reloadYardId;
    data.accountId = account.id;
    data.billToAccountId = account.id;
    data.accountName = account.businessName;
    data.transfer = null;
    data.transferToAccountId = "";
    data.advisedBy = appUser.email;

    data.instructions = account.outboundInstructions;
    data.skipSignature = account.outboundSkipSignature;

    data.createDateTime = new Date();
    data.scheduledDateTime = data.scheduledDateTime
      ? data.scheduledDateTime
      : null;
    data.arrivalDateTime = null;
    data.placementDateTime = null;
    data.endDateTime = null;
    data.departureDateTime = null;

    data.poNumber = data.poNumber ? data.poNumber : "";
    data.consigneePoNumber = data.consigneePoNumber
      ? data.consigneePoNumber
      : "";
    data.pickupNumber = data.pickupNumber ? data.pickupNumber : "";

    data.normalizedPoNumber = normalizeValue(data.poNumber);
    data.normalizedConsigneePoNumber = normalizeValue(data.consigneePoNumber);
    data.normalizedPickupNumber = normalizeValue(data.pickupNumber);

    data.carrierType = data.carrierType ? data.carrierType : "";
    data.carrier = data.carrier ? data.carrier : null;
    data.railCarNumber = data.railCarNumber ? data.railCarNumber : null;
    data.normalizedRailCarNumber = normalizeValue(data.railCarNumber);

    data.mustTarp = data.mustTarp ? data.mustTarp : false;
    data.scaleWeightUnits = data.weightUnits;

    if (data.shipTo?.state) {
      data.shipTo.state = data.shipTo.state.toUpperCase();
      data.shipTo.zipCode = data.shipTo.zipCode.toUpperCase();
    }

    data.history = [
      {
        text: `Created outbound advice.`,
        by: window.appUser?.fullName,
        date: data.createDateTime,
        type: NoteType.SHIPMENT,
      },
    ];

    if (data.notes?.length > 0) {
      data.notes.forEach((element) => {
        element.type = NoteType.GENERIC;
        element.date = new Date();
        element.by = window.appUser?.fullName;
      });
    } else data.notes = undefined;

    try {
      data.customFields = getCustomFieldsToSave(
        data.customFields,
        account?.outboundCustomFields,
      );

      if (account.generatePickupNumber) {
        data.pickupNumber = await autogenPickupNumber(account);
      } else {
        data.pickupNumber = data.pickupNumber ? data.pickupNumber : "";
      }

      await Promise.all([
        saveRemoveFiles(
          undefined,
          data,
          "attachments",
          `${FilePaths.OUTBOUND}/${Date.now()}`,
        ),
        saveRemoveFile(
          undefined,
          data,
          "bolFile",
          `${FilePaths.OUTBOUND}/${Date.now()}`,
        ),
      ]);
    } catch (err) {
      logError("outbounds:ValidateCreateButton:transform", err);
      return Promise.reject();
    }

    // clean up extra form fields
    delete data.totalQuantity;

    return data;
  };

  const onSuccess = async ({ data }) => {
    try {
      debugger;
      let outboundUpdateInput = null;
      let timeslotCreateInput = null;

      if (selectedTimeslot) {
        timeslotCreateInput = createLambdaAppointment(
          selectedTimeslot,
          null,
          data.id,
          data.accountId,
          data.accountName,
        );
        outboundUpdateInput = {
          ...data,
          timeslotId: timeslotCreateInput.id,
        };
        outboundUpdateInput = sanitizeOutboundLambda(outboundUpdateInput);
      }

      if (outboundUpdateInput || timeslotCreateInput) {
        const response = await API.post("transREST", "/outboundCreate", {
          body: {
            outboundUpdateInput,
            accountUpdateinput: null,
            timeslotCreateInput,
            shipmentLineItemCreateList: null,
            shipmentItemInventoryItemCreateList: null,
            inventoryItemUpdateList: null,
            inventoryUpdateList: null,
            user: window.appUser.email,
            reloadYardId: window.appUser.reloadYardId,
          },
        });
        if (response.error) throw response.error;
      }

      notify("Outbound advice created successfully", "success");
      redirect("/outboundShipments");
    } catch (error) {
      logError(
        `outbounds:ValidateCreateButton:onSuccess`,
        error,
        notify,
        redirect,
      );
    } finally {
      setIsSaving(false);
    }
  };

  const onFailure = (error) => {
    setIsSaving(false);
    logError("outbounds:ValidateCreateButton:onFailure", error, notify);
  };

  return (
    <>
      <Backdrop className={classes.backdrop} open={isSaving}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <SaveButton
        label="Save"
        submitOnEnter={false}
        undoable={false}
        saving={isSaving}
        handleSubmitWithRedirect={() => handleValidateSave()}
        transform={transform}
        onSuccess={onSuccess}
        onFailure={onFailure}
      />
      <ConditionalConfirm
        isOpen={open}
        loading={isSaving}
        title="Save Confirmation"
        content={confirmMessage}
        cancel="Ok"
        onClose={handleDialogClose}
      />
    </>
  );
};
